import { cn } from "@/lib/utils";

/**
 * Placeholder block shown while content loads for the first time.
 *
 * Build the loading state out of these in the shape of the content that is
 * about to appear, so the layout does not jump once data arrives.
 */
function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
	return <div className={cn("animate-pulse rounded-md bg-muted", className)} {...props} />;
}

export { Skeleton };
